import React from "react";
import VeekryptLogo from "./VeekryptLogo";
import { useTheme } from "../../contexts/ThemeContext";

export default function Logo({ className = "" }) {
  const { theme } = useTheme();
  const invertForLight = theme === "light";

  return (
    <div className={`d-flex align-items-center logo-container ${className}`} style={{ gap: "0.5rem" }}>
      <VeekryptLogo height={32} invertForLight={invertForLight} />
    </div>
  );
}
